document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-zoho-newsletter-form]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var emailInput = form.querySelector('input[name="Email"]');
      var successMsg = form.querySelector('.newsletter-form__message--success');
      var errorMsg = form.querySelector('#' + form.id + '-error') || form.querySelector('[id$="-error"]');
      var errorText = form.querySelector('[data-zoho-error-text]');
      var submitBtn = form.querySelector('button[type="submit"]');

      // Reset previous states
      if (successMsg) successMsg.hidden = true;
      if (errorMsg) errorMsg.hidden = true;

      // Basic email validation
      var email = emailInput ? emailInput.value.trim() : '';
      var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!email || !emailPattern.test(email)) {
        if (errorText) errorText.textContent = 'Introduce un correo electrónico válido.';
        if (errorMsg) errorMsg.hidden = false;
        if (emailInput) emailInput.focus();
        return;
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');
      }

      var formData = new FormData(form);

      // Zoho's endpoint doesn't return readable CORS headers, so we send
      // the request in "no-cors" mode. We can't read the response, but the
      // submission still reaches Zoho; we treat the fetch resolving as success.
      fetch(form.action, {
        method: 'POST',
        mode: 'no-cors',
        body: formData
      })
        .then(function () {
          if (successMsg) {
            successMsg.hidden = false;
            successMsg.focus();
          }
          form.reset();
        })
        .catch(function () {
          if (errorText) errorText.textContent = 'No se ha podido completar la suscripción. Inténtalo de nuevo.';
          if (errorMsg) errorMsg.hidden = false;
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute('aria-busy');
          }
        });
    });
  });
});